"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calendars = void 0;
/* @generated */
// prettier-ignore
exports.calendars = ["buddhist", "chinese", "coptic", "dangi", "ethioaa", "ethiopic", "gregory", "hebrew", "indian", "islamic", "islamic-civil", "islamic-rgsa", "islamic-tbla", "islamic-umalqura", "islamicc", "iso8601", "japanese", "persian", "roc"];